import { render, staticRenderFns } from "./index.vue?vue&type=template&id=87060252"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MeatPageHeader: require('/home/korzinka/www/front/components/MeatPage/Header.vue').default,MeatPageFooter: require('/home/korzinka/www/front/components/MeatPage/Footer.vue').default})
